/* ══════════════════════════════════════════════════════════════
   ED AFFILIATE – Script für alle ed-aff-* Sections
   1. Einblenden beim Scrollen ([data-reveal] → .is-in)
   2. Creator-Wand: Spalten einmal duplizieren, dann endlos laufen lassen
   Läuft nur einmal, reagiert auf Section-Reloads im Theme-Editor.
   ══════════════════════════════════════════════════════════════ */
(function () {
  if (window.EDAff) { window.EDAff.init(document); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var io = null;

  function initReveal(root) {
    var items = root.querySelectorAll('.ed-aff [data-reveal]:not(.is-in)');
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    }
    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }

  function initWall(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-aff-wall]'), function (wall) {
      if (wall.__affInit) return; wall.__affInit = true;
      if (designMode) { wall.classList.add('is-editor'); return; }
      if (reduce) return;
      Array.prototype.forEach.call(wall.querySelectorAll('.aff-wall__col'), function (col) {
        Array.prototype.slice.call(col.children).forEach(function (li) {
          var c = li.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-shopify-editor-block');
          var img = c.querySelector('img');
          if (img) { img.alt = ''; img.removeAttribute('fetchpriority'); img.loading = 'lazy'; }
          col.appendChild(c);
        });
      });
      wall.classList.add('is-live');
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initWall(root);
  }

  window.EDAff = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
